import React, { useEffect, useState, useCallback } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import { alpha, styled } from '@mui/material/styles';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Button from '@mui/material/Button';
import httpCommon from 'src/http-common';
import { useTable, getComparator } from 'src/components/table';
import { format } from 'date-fns';
import Container from '@mui/material/Container';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

import { RouterLink } from 'src/routes/components';
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import Label from 'src/components/label';
import { _userList, _roles, USER_STATUS_OPTIONS } from 'src/_mock';
import TableHead from '@mui/material/TableHead';
import {
  TableSortLabel,
  TextField,
  InputAdornment,
  Popover,
  List,
  ListItem,
  ListItemIcon,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { orderBy } from 'lodash';
import Iconify from 'src/components/iconify';

import { paths } from 'src/routes/paths';
import RejectedStatus from './RejectedStatus';
import InProgressStatus from './InProgressStatus';
import DfltImg from './no-pictures.png';
import ViewIcon from './menuIcn.jpg';
import CompleteStatus from './CompleteStatus';
import PendingStatus from './PendingStatus';
import CompleteToRating from './CompleteToRating';
import LoderImg from './ajax-loader_WR.gif';

const columns = [
  { id: 'attachment', label: 'WR Image', minWidth: 130, width: 130 },
  { id: 'wkr_mst_wr_no', label: 'WR#', minWidth: 100 },
  { id: 'wkr_mst_org_date', label: 'WR Date', minWidth: 150 },
  { id: 'wkr_mst_wr_descs', label: 'WR Description ', minWidth: 50 },
  { id: 'wkr_mst_service', label: 'Work Area', minWidth: 130 },
  { id: 'wkr_mst_location', label: 'Level', minWidth: 150 },
  { id: 'wkr_mst_org_locn', label: 'Location', width: 50 },
  { id: 'wkr_mst_wr_status', label: 'Status', minWidth: 100 },
];

const STATUS_OPTIONS = [...USER_STATUS_OPTIONS, { value: 'all', label: 'All' }];

const defaultFilters = {
  name: '',
  role: [],
  status: 'pending',
};

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: 'white',
  boxShadow: 24,
  padding: 15,
  display: 'flex',
  flexDirection: 'column',
  borderRadius: 6,
  width: '80%', // Set the maximum width for the Modal
  maxHeight: '85vh', // Set the maximum height for the Modal
  overflowY: 'auto',
};
const closeIconStyle = {
  position: 'absolute',
  top: 10,
  right: 10,
  color: '#000',
};

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function WorkListView({ currentComponentVisible }) {
  const table = useTable();

  const [currentComponentVisible2, setCurrentComponentVisible] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const settings = useSettingsContext();

  const [WorkReqData, setWorkReqData] = useState([]);
  const [searchInput, setSearchInput] = useState('');

  const [selectedRowID, setSelectedRowID] = useState(null);

  const [selectedRows, setSelectedRows] = useState([]);
  const [order, setOrder] = useState('asc');
  const [orderByColumn, setOrderByColumn] = useState('');

  const userId = localStorage.getItem('QRId');
  const site_Cd = localStorage.getItem('Hsp');
  const [workReqestNumber, setWorkReqNo] = useState(null);

  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [filteredData, setFilteredData] = useState(data);

  const [filters, setFilters] = useState(defaultFilters);

  const [activeButton, setActiveButton] = useState('second');

  const [isModalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);

  const [inProgressModalOpen, setInProgressModalOpen] = useState(false);
  const [completeModalOpen, setCompleteModalOpen] = useState(false);
  const [pendingModalOpen, setPendingModalOpen] = useState(false);
  const [completeToRatModalOpen, setCompleteToRatModalOpen] = useState(false);

  // chdck setting mode
  useEffect(() => {
    const handleThemeOnLoad = () => {
      const storedValue = localStorage.getItem('dataDark');

      if (storedValue === 'dark') {
        document.body.classList.add('custom-darkClass');
      } else {
        document.body.classList.remove('custom-darkClass');
      }
    };
    handleThemeOnLoad();
    return () => {
      document.body.classList.remove('custom-darkClass');
    };
  }, []);

  const handleSort = (columnId) => {
    const isAsc = orderByColumn === columnId && order === 'asc';
    const newOrder = isAsc ? 'desc' : 'asc';
    setOrder(newOrder);
    setOrderByColumn(columnId);
    const sortedData = orderBy(data, columnId, newOrder);
    // Update your data or state with the sorted data
    setData(sortedData);
  };

  if (currentComponentVisible2) {
    document.body.classList.add('customNav');
  } else {
    document.body.classList.remove('customNav');
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // Get Api data
  useEffect(() => {
    const fetchUserWorkListData = async () => {
      try {
        const response = await httpCommon.get(
          `/WorkRequestList.php?id=${userId}&siteCd=${site_Cd}`
        );
        // console.log("droPPList View__", response);
        if (response.data.status === 'SUCCESS') {
          setData(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchUserWorkListData(); // Call the function directly
  }, [userId, site_Cd]);

  useEffect(() => {
    const filteredData2 = data.filter((item) => item.wkr_mst_wr_status === 'W');
    setFilteredData(filteredData2);
  }, [data]);

  const handleSearchChange = (e) => {
    const inputValue = e.target.value.toLowerCase();

    const filteredResults = data.filter(
      (item) =>
        item.wkr_mst_wr_no.toLowerCase().includes(inputValue) ||
        item.wkr_mst_wr_descs.toLowerCase().includes(inputValue) ||
        item.wkr_mst_location.toLowerCase().includes(inputValue) ||
        item.wkr_mst_service.toLowerCase().includes(inputValue)
    );

    setFilteredData(filteredResults);

    setSearchInput(inputValue);
  };
  const handleClearClick = () => {
    setSearchInput('');
    setFilteredData(data);
  };
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event, mst_RowID, wkr_mst_wr_no) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowID(mst_RowID);
    setWorkReqNo(wkr_mst_wr_no);

    const selectedItem = data.find((item) => item.mst_RowID === mst_RowID);
    if (selectedItem.wkr_mst_wr_status === 'D' && mst_RowID) {
      setModalData(selectedItem);
      setModalOpen(true);
    } else if (selectedItem.wkr_mst_wr_status === 'A' && selectedItem.wrk_sts_status !== 'CMP') {
      setModalData(selectedItem);
      setInProgressModalOpen(true);
    } else if (
      selectedItem.wkr_mst_wr_status === 'A' &&
      selectedItem.wrk_sts_status === 'CMP' &&
      selectedItem.ratingCMP === null
    ) {
      setModalData(selectedItem);
      setCompleteToRatModalOpen(true);
    } else if (selectedItem.wkr_mst_wr_status === 'A' && selectedItem.wrk_sts_status === 'CMP') {
      setModalData(selectedItem);
      setCompleteModalOpen(true);
    } else if (selectedItem.wkr_mst_wr_status === 'W') {
      setModalData(selectedItem);
      setPendingModalOpen(true);
    }
  };
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedRowID(null);
  };
  const closeModalInProgress = () => {
    setInProgressModalOpen(false); // Close the modal
  };
  // const handleView = () => {
  //   console.log("itemId__",data);
  //   const selectedItem = data.find(item => item.mst_RowID === selectedRowID);
  //   if(selectedItem.wkr_mst_wr_status === 'D' && selectedItem ){
  //     console.log("selectedItem__",selectedItem);
  //     setModalData(selectedItem);
  //     setModalOpen(true);
  //   }
  // };

  // Complete model close setCompleteModalOpen
  const closeModal = () => {
    setModalOpen(false); // Close the modal
  };

  // Pending model close setPendingModalOpen
  const closeModalPending = () => {
    // fetchUserWorkListData();
    setPendingModalOpen(false); // Close the modal
  };

  const closeModalComplete = () => {
    // fetchUserWorkListData();
    // setFilters(defaultFilters);
    setCompleteModalOpen(false); // Close the modal
  };

  // completeToRatModalOpen
  const closeModalCompleteTorat = () => {
    setCompleteToRatModalOpen(false); // Close the modal
  };

  const handleDelete = (row) => {
    // Implement your handleDelete logic here
    // This function will be called when the "Delete" button is clicked.
  };
  const handleFilters = useCallback(
    (name, value) => {
      table.onResetPage();
      setFilters((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    },
    [table]
  );
  const handleFilterStatus = useCallback(
    (event, newValue) => {
      handleFilters('status', newValue);
    },
    [handleFilters]
  );
  const showCurrentComponent = () => {
    setCurrentComponentVisible(false);
    setActiveButton('second');
  };

  const callSecondComponent = () => {
    setCurrentComponentVisible(true);
    setActiveButton('first');
    // You can add logic here to call the second component or navigate to it.
  };
  const handleTabClick = (tabValue) => {
    if (tabValue === 'inProgress') {
      const filteredArray = data.filter(
        (item) => item.wkr_mst_wr_status === 'A' && item.wrk_sts_status !== 'CMP'
      );
      setPage(0);
      setFilteredData(filteredArray);
    } else if (tabValue === 'pending') {
      const filteredArray = data.filter((item) => item.wkr_mst_wr_status === 'W');
      setPage(0);
      setFilteredData(filteredArray);
    } else if (tabValue === 'rejected') {
      const filteredArray = data.filter((item) => item.wkr_mst_wr_status === 'D');
      setPage(0);
      setFilteredData(filteredArray);
    } else if (tabValue === 'completeToRate') {
      const filteredArray = data.filter(
        (item) =>
          item.wkr_mst_wr_status === 'A' && item.wrk_sts_status === 'CMP' && item.ratingCMP === null
      );
      setPage(0);
      setFilteredData(filteredArray);
    } else if (tabValue === 'complete') {
      const filteredArray = data.filter(
        (item) =>
          item.wkr_mst_wr_status === 'A' && item.wrk_sts_status === 'CMP' && item.ratingCMP !== null
      );
      setPage(0);
      setFilteredData(filteredArray);
    } else if (tabValue === 'all') {
      setPage(0);
      setFilteredData(data);
    }
  };

  return (
    <div>
      <Container maxWidth={settings.themeStretch ? false : 'lg'}>
        <CustomBreadcrumbs
          heading="Work Request List"
          className="LstVw"
          links={[
            { name: 'Dashboard', href: paths.dashboard.root },
            { name: 'User', href: paths.dashboard.user.root },
            { name: 'List' },
          ]}
          action={
            <Button
              component={RouterLink}
              href={paths.dashboard.work_request.new}
              variant="contained"
              startIcon={<Iconify icon="mingcute:add-line" />}
            >
              New Request
            </Button>
          }
          sx={{
            mb: { xs: 3, md: 5 },
          }}
        />

        <div className="TabForDesktop">
          <Grid container alignItems="center">
            <Grid item xs={9}>
              <Tabs
                value={filters.status}
                onChange={handleFilterStatus}
                sx={{
                  px: 2.5,
                  boxShadow: (theme) => `inset 0 -2px 0 0 ${alpha(theme.palette.grey[500], 0.08)}`,
                }}
              >
                {STATUS_OPTIONS.map((tab) => (
                  <Tab
                    key={tab.value}
                    iconPosition="end"
                    value={tab.value}
                    label={tab.label}
                    onClick={() => handleTabClick(tab.value)}
                    icon={
                      <Label
                        variant={
                          ((tab.value === 'all' || tab.value === filters.status) && 'filled') ||
                          'soft'
                        }
                        color={
                          (tab.value === 'inProgress' && 'secondary') ||
                          (tab.value === 'pending' && 'warning') ||
                          (tab.value === 'completeToRate' && 'info') ||
                          (tab.value === 'complete' && 'success') ||
                          (tab.value === 'rejected' && 'error') ||
                          'default'
                        }
                      >
                        {tab.value === 'pending' &&
                          data.filter((user) => user.wkr_mst_wr_status === 'W').length}{' '}
                        {/* Pending */}
                        {tab.value === 'inProgress' &&
                          data.filter(
                            (user) =>
                              user.wkr_mst_wr_status === 'A' && user.wrk_sts_status !== 'CMP'
                          ).length}{' '}
                        {/* In Progress */}
                        {tab.value === 'rejected' &&
                          data.filter((user) => user.wkr_mst_wr_status === 'D').length}{' '}
                        {/* Rejected */}
                        {tab.value === 'completeToRate' &&
                          data.filter(
                            (user) =>
                              user.wkr_mst_wr_status === 'A' &&
                              user.wrk_sts_status === 'CMP' &&
                              user.ratingCMP === null
                          ).length}{' '}
                        {/* complete to rate */}
                        {tab.value === 'complete' &&
                          data.filter(
                            (user) =>
                              user.wkr_mst_wr_status === 'A' &&
                              user.wrk_sts_status === 'CMP' &&
                              user.ratingCMP !== null
                          ).length}{' '}
                        {/* complete */}
                        {tab.value === 'all' && data.length}
                      </Label>
                    }
                    className={`customTab-${tab.value} ${
                      filters.status === tab.value ? 'active' : ''
                    }`}
                  />
                ))}
              </Tabs>
            </Grid>
            <Grid item xs={3}>
              {/* Buttons on the right side */}
              <Grid container justifyContent="flex-end" spacing={1} className="tglLftRgt">
                <Grid item>
                  <Button
                    variant="contained"
                    style={{
                      border: '1px solid #8080808a',
                      fontSize: '12px',
                      background: activeButton === 'first' ? '#80808029' : 'transparent',
                      color: '#000',
                    }}
                    onClick={showCurrentComponent}
                    component={RouterLink}
                    href={paths.dashboard.work_request.list}
                  >
                    <Iconify icon="carbon:switcher" />
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    style={{
                      border: '1px solid #8080808a',
                      fontSize: '12px',
                      background: activeButton === 'second' ? '#80808029' : 'transparent',
                      color: '#000',
                    }}
                    onClick={callSecondComponent}
                  >
                    <Iconify icon="carbon:list" />
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={6} sx={{ marginTop: 4, marginBottom: 4, marginLeft: 0 }}>
              <TextField
                variant="outlined"
                fullWidth
                placeholder="Search..."
                value={searchInput}
                onChange={handleSearchChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Iconify icon="carbon:search" />
                    </InputAdornment>
                  ),
                  endAdornment: searchInput ? (
                    <InputAdornment
                      position="end"
                      onClick={handleClearClick}
                      className="serchclr_btn"
                    >
                      <Iconify icon="pajamas:clear" />
                    </InputAdornment>
                  ) : null,
                }}
                style={{ width: '100%' }}
              />
            </Grid>
          </Grid>
          <Paper>
            <TableContainer>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    {columns.map((column) => {
                      const isColumnActive = orderByColumn === column.id;
                      const isAsc = isColumnActive && order === 'asc';

                      return (
                        <TableCell
                          key={column.id}
                          style={{ minWidth: column.minWidth, width: column.width }}
                        >
                          <TableSortLabel
                            active={isColumnActive}
                            direction={isColumnActive ? order : 'asc'}
                            onClick={() => handleSort(column.id)}
                          >
                            {column.label}
                          </TableSortLabel>
                        </TableCell>
                      );
                    })}
                    <TableCell key="empty" />
                  </TableRow>
                </TableHead>

                <TableBody>
                  {filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => (
                      <TableRow key={row.id}>
                        {columns.map((column) => {
                          let cellContent = row[column.id];

                          if (column.id === 'attachment') {
                            return (
                              <TableCell key={column.id} valign="middle">
                                {row[column.id] ? (
                                  <img
                                    src={`${row[column.id]}`}
                                    alt={`userImg ${row.id}`}
                                    width="100"
                                    height="100"
                                    className="lstImgUsr"
                                  />
                                ) : (
                                  <img
                                    src={DfltImg} // Replace with the path to your demo image
                                    alt="Demo"
                                    width="100"
                                    height="100"
                                    className="lstImgUsr dm"
                                  />
                                )}
                              </TableCell>
                            );
                          }

                          if (column.id === 'wkr_mst_wr_descs' && row[column.id].length > 80) {
                            cellContent = `${row[column.id].substring(0, 80)}...`;
                          } else {
                            cellContent = row[column.id];
                          }
                          if (column.id === 'wkr_mst_org_date') {
                            const dateObject = new Date(row[column.id].date);
                            const formattedDate = format(dateObject, 'dd-MM-yyyy HH:mm', {
                              useAdditionalDayOfYearTokens: true,
                            });
                            // const time = dateObject.toTimeString().slice(0, 5); // Get "HH:MM" from the time part

                            cellContent = `${formattedDate}`;
                          }

                          if (column.id === 'wkr_mst_wr_status') {
                            let className = '';
                            let statusText = row[column.id];

                            switch (true) {
                              case row[column.id] === 'W':
                                className = 'activeStatusList';
                                statusText = 'Pending';
                                break;
                              case row[column.id] === 'A' && row.wrk_sts_status !== 'CMP':
                                className = 'inProgressStatusList';
                                statusText = 'In Progress';
                                break;
                              case row[column.id] === 'D':
                                className = 'rejectedStatusList';
                                statusText = 'rejected';
                                break;

                              case row[column.wkr_mst_wr_status] === 'A' &&
                                row.wrk_sts_status === 'CMP' &&
                                row.ratingCMP === null:
                                className = 'completeStatus';
                                statusText = 'Complete To Rate';
                                break;

                              case row[column.id] === 'A' &&
                                row.wrk_sts_status === 'CMP' &&
                                row.ratingCMP !== null:
                                className = 'completeStatus2';
                                statusText = 'complete';
                                break;

                              default:
                                break;
                            }

                            cellContent = <span className={className}>{statusText}</span>;
                          }

                          return <TableCell key={column.id}>{cellContent}</TableCell>;
                        })}
                        <TableCell>
                          <IconButton
                            aria-label={`Delete Row ${row.ref_RowId}`}
                            className="openVieIcn"
                            onClick={(event) =>
                              handleClick(event, row.mst_RowID, row.wkr_mst_wr_no)
                            }
                          >
                            <img src={ViewIcon} alt="viewIcon" className="lstViweIcnLs" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 15, 20]}
              component="div"
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </div>

        {/* Pending Model */}

        <div>
          <BootstrapDialog
            onClose={closeModalPending}
            aria-labelledby="customized-dialog-title"
            open={pendingModalOpen}
            PaperProps={{
              style: {
                maxWidth: '100%', // Set the desired width here
              },
            }}
          >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
              {workReqestNumber} Pending Status
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={closeModalPending}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: 'red',
              }}
            >
              <Iconify icon="carbon:close-outline" />
            </IconButton>
            <DialogContent dividers>
              <PendingStatus selectedRowID={selectedRowID} closeModalPending={closeModalPending} />
            </DialogContent>
          </BootstrapDialog>
        </div>

        {/* model InProgress Popup data */}

        <div>
          <BootstrapDialog
            onClose={closeModalInProgress}
            aria-labelledby="customized-dialog-title"
            open={inProgressModalOpen}
            PaperProps={{
              style: {
                maxWidth: '100%', // Set the desired width here
              },
            }}
          >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
              {workReqestNumber} In Progress Status
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={closeModalInProgress}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: 'red',
              }}
            >
              <Iconify icon="carbon:close-outline" />
            </IconButton>
            <DialogContent dividers>
              <InProgressStatus selectedRowID={selectedRowID} />
            </DialogContent>
          </BootstrapDialog>
        </div>
        {/* Complete To Reate */}

        <div>
          <BootstrapDialog
            onClose={closeModalCompleteTorat}
            aria-labelledby="customized-dialog-title"
            open={completeToRatModalOpen}
            PaperProps={{
              style: {
                maxWidth: '100%', // Set the desired width here
              },
            }}
          >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
              {workReqestNumber} Complete To Rate Status
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={closeModalCompleteTorat}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: 'red',
              }}
            >
              <Iconify icon="carbon:close-outline" />
            </IconButton>
            <DialogContent dividers>
              <CompleteToRating
                selectedRowID={selectedRowID}
                closeModalComplete={closeModalCompleteTorat}
              />
            </DialogContent>
          </BootstrapDialog>
        </div>

        {/* Complete Status */}

        <div>
          <BootstrapDialog
            onClose={closeModalComplete}
            aria-labelledby="customized-dialog-title"
            open={completeModalOpen}
            PaperProps={{
              style: {
                maxWidth: '100%', // Set the desired width here
              },
            }}
          >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
              {workReqestNumber} Complete Status
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={closeModalComplete}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: 'red',
              }}
            >
              <Iconify icon="carbon:close-outline" />
            </IconButton>
            <DialogContent dividers>
              <CompleteStatus
                selectedRowID={selectedRowID}
                closeModalComplete={closeModalComplete}
              />
            </DialogContent>
          </BootstrapDialog>
        </div>

        {/* model Rejected data */}

        <div>
          <BootstrapDialog
            onClose={closeModal}
            aria-labelledby="customized-dialog-title"
            open={isModalOpen}
            PaperProps={{
              style: {
                maxWidth: '100%', // Set the desired width here
              },
            }}
          >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
              {workReqestNumber} Rejected Status
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={closeModal}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: 'red',
              }}
            >
              <Iconify icon="carbon:close-outline" />
            </IconButton>
            <DialogContent dividers>
              <RejectedStatus selectedRowID={selectedRowID} />
            </DialogContent>
          </BootstrapDialog>
        </div>
      </Container>
    </div>
  );
}

WorkListView.propTypes = {
  currentComponentVisible: PropTypes.bool.isRequired, // Assuming it's a boolean
};
